import PropTypes from 'prop-types'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { useEffect, useState } from 'react'

import { Box, Stack, Typography } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import DeleteIcon from '@mui/icons-material/Delete'

import { HEX_COLORS } from '../../store/constants'
import { IntervalFormatter } from '../../utils'
import { IconButton } from '../default'

const ConsumptionRangesTable = ({ intervalList, onDelete }) => {

    const [tableFormattedIntervalList, setTableFormattedIntervalList] = useState([])

    useEffect(() => {

        if (intervalList) {
            const formatted = IntervalFormatter.tableIntervalFormatter(intervalList)
            setTableFormattedIntervalList(formatted)
        }

    }, [intervalList])

    const columns = [
        {
            accessorKey: 'consumptionRangeId',
            enableSorting: false,
            header: 'ID',
            size: 80
        },
        {
            accessorKey: 'operatorLabel',
            header: 'Consumo do Limite',
            enableSorting: false,
            size: 100
        },
        {
            accessorFn: (row) => isNaN(row.minValue) ? "—" : `${row.minValue}%`,
            id: 'minValue',
            header: 'Mínimo',
            size: 80
        },
        {
            accessorFn: (row) => isNaN(row.maxValue) ? "—" : `${row.maxValue}%`,
            id: 'maxValue',
            header: 'Máximo',
            enableSorting: false,
            size: 80
        },
        {
            accessorKey: 'actionLabel',
            header: 'Ação',
            enableSorting: false,
            size: 100
        },
        {
            accessorFn: (row) => row.percentage ? `${row.percentage}%` : "—",
            id: 'percentage',
            header: 'Percentual',
            enableSorting: false,
            size: 80
        },
        {
            accessorKey: 'color',
            header: 'Cor',
            Cell: ({ cell }) => renderColorColumn(cell),
            enableSorting: false
        }
    ]

    const renderColorColumn = (cell) => {
        const color = cell.getValue()
        return (
            <Box display="flex" alignItems="center" gap={1}>
                <CircleIcon sx={{ color }} />
                {HEX_COLORS.find(c => c.value === color)?.label || color}
            </Box>
        )
    }

    const renderRowActions = ({ row }) => {
        const id = row.original.consumptionRangeId
        return (
            <IconButton onClick={() => onDelete(id)}>
                <DeleteIcon />
            </IconButton>
        )
    }

    const table = useMaterialReactTable({
        columns,
        data: tableFormattedIntervalList,
        localization: MRT_Localization_PT_BR,

        // Actions Column
        enableRowActions: true,
        positionActionsColumn: 'last',
        renderRowActions: renderRowActions,

        enableTopToolbar: false,
        enablePagination: false,
        enableGlobalFilter: false,
        enableColumnFilters: false,

        enableKeyboardShortcuts: false,
        enableColumnActions: false,

        initialState: {
            density: 'compact',
            sorting: [
                { id: 'minValue', desc: false }
            ]
        },

        // Mui Style Props
        muiTablePaperProps: ({ table }) => ({
            elevation: 0,
            style: {
                zIndex: table.getState().isFullScreen ? 1300 : undefined,
            }
        }),
        mrtTheme: {
            baseBackgroundColor: "#FFFFFF"
        },

        renderEmptyRowsFallback: () => (
            <Box p={1} justifyItems="center">
                <Typography variant='body2'>Nenhum perfil de consumo definido até o momento</Typography>
            </Box>
        )

    })

    return (
        <Stack gap={3}>
            <Typography fontWeight="bold">Regras Aplicadas</Typography>

            <MaterialReactTable table={table} />
        </Stack>
    )
}

ConsumptionRangesTable.propTypes = {
    intervalList: PropTypes.array,
    onDelete: PropTypes.func.isRequired
}

export default ConsumptionRangesTable